import React, { createContext, useCallback, useContext, useState } from 'react';

/**
 * DataVersionContext
 *
 * Cross-page cache invalidation. Pages that fetch data should add
 * `version` to their useEffect deps. After a successful upload (or any
 * mutation that affects multiple pages), call `bump()` to trigger
 * automatic refetch on every visible page.
 */
const DataVersionContext = createContext({ version: 0, bump: () => {} });

export function DataVersionProvider({ children }) {
  const [version, setVersion] = useState(0);
  const bump = useCallback(() => setVersion((v) => v + 1), []);
  return (
    <DataVersionContext.Provider value={{ version, bump }}>
      {children}
    </DataVersionContext.Provider>
  );
}

export const useDataVersion = () => useContext(DataVersionContext);
